import { BaseRepository } from '@Ravnur-Inc/http';
import pathes from '@Ravnur-Inc/shared/config/pathes';
import { Job$Response } from '@Ravnur-Inc/shared/types/Job';

export default class ProcessingRepository extends BaseRepository<Job$Response> {
  constructor() {
    super(`${pathes.JOB}/current`);
  }
}
